import { IconButton, InputAdornment, TextFieldProps } from '@mui/material'
import React, { useState } from 'react'
import { passwordRegexString } from 'app/utils/Regex'
import {
  TextValidator,
  ValidatorComponentProps,
} from 'react-material-ui-form-validator'
import { Visibility, VisibilityOff } from '@mui/icons-material'

function PasswordTextValidator(
  props: ValidatorComponentProps & TextFieldProps
) {
  const [secured, setSecured] = useState(true)
  const handleClickToggleSecured = () => {
    setSecured((prev) => !prev)
  }

  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault()
  }
  return (
    // @ts-ignore
    <TextValidator
      variant="outlined"
      label="Password"
      type={secured ? 'password' : 'Text'}
      size="small"
      validators={[`matchRegexp:${passwordRegexString}`]}
      errorMessages={['']}
      {...props}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClickToggleSecured}
              onMouseDown={handleMouseDownPassword}
              edge="end"
              size="large">
              {secured ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
        ...props.InputProps
      }}
    />
  );
}

export default React.memo(PasswordTextValidator)
